import type { FunctionComponent } from 'react';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { mapLinkIconPlacement } from '../../../app-kit/helpers/mapLinkIconPlacement';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { UpdatePropertyDetailsModal } from './UpdatePropertyDetailsModal';

const addEntryPointTrackingParamToUrl = (baseUrl: string, entryPoint: string) => {
  const url = new URL(baseUrl);
  url.search = `entryPoint=${entryPoint}`;

  return url.toString();
};

interface UpdatePropertyDetailsModalWithDataProps {
  opened: boolean;
  onClose: () => void;
  entryPoint: string;
}

export const UpdatePropertyDetailsModalWithData: FunctionComponent<
  UpdatePropertyDetailsModalWithDataProps
> = ({ opened, onClose, entryPoint }) => {
  const queryResult = usePropertyPageQuery();
  if (!queryResult?.data?.propertyPageBySlugV3?.updatePropertyDetailsModal) return null;

  const { subtitle, link } = queryResult.data.propertyPageBySlugV3.updatePropertyDetailsModal;

  const mappedLink = {
    ...link,
    url: addEntryPointTrackingParamToUrl(link.url, entryPoint),
    variant: mapApiWeblinkVariantToLinkVariant(link.variant),
    iconInfo: link.iconInfo
      ? {
          name: link.iconInfo.name,
          placement: mapLinkIconPlacement(link.iconInfo.placement),
        }
      : null,
  };

  return (
    <UpdatePropertyDetailsModal
      opened={opened}
      onClose={onClose}
      subtitle={subtitle}
      link={mappedLink}
    />
  );
};
